// External libraries
import React, { useEffect } from 'react';

// Internal modules
import { features, logger } from '@/lib';
import { Streamline } from '../Streamline';
import { weasleyFlowType } from '../constants';
import { SignupFields } from '@/components/SignupFields';
import { Section } from '@/components/Form/StyledComponents';
import { ContactFieldsSection } from '@/components/ContactInformation';
import { GenericSubmission } from '../../../FormSubmission';
// @ts-expect-error untyped import
import { AccountSectionHeader } from '../../../Components';

export const ForcedPassword = (): JSX.Element => {
  const isStreamlineExperience = features.isActive(
    'isStreamlineForcedExperience',
  );

  useEffect(() => {
    logger.info(
      isStreamlineExperience
        ? 'rendering_streamline_password_forced_sign_up_flow'
        : 'rendering_password_forced_sign_up_flow',
    );
  }, []);

  if (isStreamlineExperience) {
    return <Streamline flowType={weasleyFlowType.FORCED_WITH_PASSWORD_FLOW} />;
  }

  return (
    <>
      <Section>
        <AccountSectionHeader />
        {/*TS conversion PR, so avoiding changing prod code for now
          @ts-expect-error - this is not a prop, why are we passing it? */}
        <Section as="div">
          <ContactFieldsSection mb="gutter" showHeading={false} />
          <SignupFields />
        </Section>
      </Section>
      <GenericSubmission />
    </>
  );
};
